import React, { useState } from 'react';
import { Modal, Form, Input, Button, Descriptions, message } from 'antd';
import ApiSelect from "../../../../utils/ApiSelect";
import api from '../../../../utils/api';

export default function JoinCompanyModal({ visible, onCancel, onSuccess }) {
  const [form] = Form.useForm();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCompanyChange = (val, option) => {
    if (option && option.original) {
      setSelectedCompany(option.original);
    } else {
      setSelectedCompany(null);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (!selectedCompany) {
        message.error('请选择企业');
        return;
      }

      const payload = {
        companyId: selectedCompany.id,
        position: values.position,
        realName: values.realName, // Optional
        isPrimary: 0 // Default to non-primary
      };

      setLoading(true);
      const res = await api.post('/approvals/submit', {
        type: 'JOIN_COMPANY',
        payload: JSON.stringify(payload),
        remark: values.remark
      });

      if (res && res.code === 200) {
        message.success('申请已提交');
        onSuccess();
        onCancel();
      } else {
        message.error(res.message || '提交失败');
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="加入企业"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>取消</Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleSubmit}>提交申请</Button>
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item label="搜索企业" name="companyId" rules={[{ required: true, message: '请选择企业' }]}>
          <ApiSelect
            apiUrl="/companies"
            labelKey="nameCn"
            valueKey="id"
            placeholder="请输入企业名称搜索"
            onChange={handleCompanyChange}
          />
        </Form.Item>
        
        {selectedCompany && (
          <Descriptions column={1} bordered size="small" style={{ marginBottom: 16 }}>
            <Descriptions.Item label="企业名称">{selectedCompany.nameCn}</Descriptions.Item>
            <Descriptions.Item label="英文名">{selectedCompany.nameEn}</Descriptions.Item>
            <Descriptions.Item label="信用代码">{selectedCompany.licenseNumber}</Descriptions.Item>
          </Descriptions>
        )}

        <Form.Item label="申请职位" name="position" rules={[{ required: true }]}>
          <Input placeholder="例如：销售经理" />
        </Form.Item>
        <Form.Item label="组织内称呼" name="realName">
          <Input placeholder="建议填写真实姓名，或者一些企业组织内的习惯称呼" />
        </Form.Item>
        <Form.Item label="备注" name="remark">
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
